<template>
    <div>
    <v-row>
        <v-col cols="1"></v-col>
        <v-col cols="10">
            <p class="text-h3 text-primary">Koszyk</p>
            <v-row align="center">
                <v-col cols="12">
                <p class="mt-6 text-h5 text-weight-light" v-if="!CartNotEmpty()">
                    <v-row justify=center><v-img width="100px" src="../assets/empty_cart.png"></v-img></v-row>
                    <v-row justify="center">
                        Koszyk jest pusty <br />
                    </v-row>
                    <v-row justify="center">
                        <v-btn color="primary" @click="$router.push('/sklep_koldry')">Przejdź do sklepu</v-btn>
                    </v-row>
                </p>
                </v-col>
                <v-col cols="12">
                <p class="mt-6" v-if="CartNotEmpty()">
                    <v-card
                        v-for="(item, i) in getProdInCart"
                        :key="i"
                        variant="outlined"
                        class="mt-2"
                    >  
                        <v-card-title class="text-h6"> {{ item.prod_name }} </v-card-title>
                        <v-card-subtitle class="subtitle-1 text-weight-light"> {{ item.size }}cm, {{ item.thickness }} ({{ item.weight }}g)</v-card-subtitle>
                        <br />
                        <v-row justify="center">
                            <v-col cols="12">
                            <p class="text-h6 text-primary text-center"> {{ item.price }}zł </p>
                            <p class="text-h5 text-weight-light text-center">
                                <v-btn variant="outlined" size="x-small" icon="mdi-menu-up" @click="quantitiy_up(item, i)"></v-btn>
                                {{ item.quantity }}
                                <v-btn variant="outlined" size="x-small" icon="mdi-menu-down" @click="quantitiy_down(item, i)"></v-btn>
                            </p>
                            <p class="text-end">
                                <v-btn variant="outlined" size="x-small" prepend-icon="mdi-delete" @click="removeProduct(i)">Usuń</v-btn>
                            </p>
                            </v-col>
                        </v-row>
                    </v-card>

                    <v-row class="mt-5 justify-end">
                        <p class="text-h4 text-primary">
                            {{ price_sum() }}zł
                        </p>
                    </v-row>

                    <v-row class="justify-center">
                        <v-btn color="primary" @click="$router.push('/koszyk-dane')">Przejdź dalej</v-btn>
                    </v-row>
                </p>
                </v-col>
                <br />
            </v-row>
        </v-col>
        <v-col cols="1"></v-col>
    </v-row>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    data () {
      return {
        quantit: '',
      }
    },
    computed: {
      ...mapGetters([
        'getProdInCart',
      ]),
    },
    methods: {
        ...mapActions([
           'removeProduct',
           'changeQuantity',
        ]),
        CartNotEmpty() {
            return this.getProdInCart.length > 0;
        },
        quantitiy_up(arr, index) {
            var newQuan = arr.quantity + +1
            var newPrice = (arr.price / arr.quantity) * newQuan
            var data = {'index': index, 'quantity': newQuan, 'price': newPrice}
            this.changeQuantity(data) 
        },
        quantitiy_down(arr, index) {
            if(arr.quantity <= 1) {
                this.removeProduct(index)
            }else{
                var newQuan = arr.quantity - +1
                var newPrice = (arr.price / arr.quantity) * newQuan
                var data = {'index': index, 'quantity': newQuan, 'price': newPrice}
                this.changeQuantity(data) 
            }
        },
        price_sum() {
            return this.getProdInCart.reduce((current, next) =>
                current + next.price, 0);
        },
        remove(index) {
            this.removeProduct(index);
        },
    },
  }
</script>